export var SlideoutCssClass;
(function (SlideoutCssClass) {
    SlideoutCssClass["Base"] = "iress-slideout";
    // Props
    SlideoutCssClass["Show"] = "iress-slideout--show";
    SlideoutCssClass["Size"] = "iress-slideout--size";
    SlideoutCssClass["OverlayPanel"] = "iress-slideout__overlay-panel";
})(SlideoutCssClass || (SlideoutCssClass = {}));
export var PushElementCssClass;
(function (PushElementCssClass) {
    PushElementCssClass["Base"] = "iress-push-element";
    PushElementCssClass["Active"] = "iress-push-element--active";
})(PushElementCssClass || (PushElementCssClass = {}));
export var SlideoutMode;
(function (SlideoutMode) {
    SlideoutMode["Overlay"] = "overlay";
    SlideoutMode["Push"] = "push";
})(SlideoutMode || (SlideoutMode = {}));
export var SlideoutSize;
(function (SlideoutSize) {
    SlideoutSize["Sm"] = "sm";
    SlideoutSize["Md"] = "md";
    SlideoutSize["Lg"] = "lg";
})(SlideoutSize || (SlideoutSize = {}));
export var SlideoutPosition;
(function (SlideoutPosition) {
    SlideoutPosition["Right"] = "right";
    SlideoutPosition["Left"] = "left";
})(SlideoutPosition || (SlideoutPosition = {}));
export var SlideoutSlot;
(function (SlideoutSlot) {
    SlideoutSlot["Footer"] = "footer";
})(SlideoutSlot || (SlideoutSlot = {}));
//# sourceMappingURL=slideout.types.js.map